import React, { useEffect } from 'react';
import jsPDF from 'jspdf';

const GeneratePDF = ({ format }) => {
  const generatePDF = () => {
    const doc = new jsPDF();

    if (format === 'format1') {
      // Format 1: Termo de Entrega
      doc.setFontSize(12);
      doc.text("REPÚBLICA DE ANGOLA", 105, 20, { align: 'center' });
      doc.text("MINISTÉRIO DAS RELAÇÕES EXTERIORES", 105, 27, { align: 'center' });
      doc.text("EMBAIXADA DA REPÚBLICA DE ANGOLA NO JAPÃO", 105, 34, { align: 'center' });
      
      doc.setFontSize(14);
      doc.text("TERMO DE ENTREGA", 105, 50, { align: 'center' });

      doc.setFontSize(12);
      doc.text("Por intermédio desta, se faz constar que foi entregue o valor em YJP (xxxxxxx YEN);", 20, 70);
      doc.text("com o seguinte objectivo:", 20, 77);
      doc.text("Reembolso a favor do Sr. Keisuke Yamada pela compra de medicamento para a Sra.", 20, 84);
      doc.text("Embaixadora.", 20, 91);

      doc.setFont("bold");
      doc.text("SECTOR DE FINANÇAS DA(O) EMBAIXADA DA REPÚBLICA DE ANGOLA NO JAPÃO, Tóquio,", 20, 105);
      doc.text("7 de Outubro de 2024", 20, 112);

      doc.setFontSize(12);
      doc.setFont("normal");
      doc.text("Entreguei", 40, 140);
      doc.text("Recebi", 140, 140);

      doc.text("O Adido Financeiro", 40, 147);
      doc.text("__________________", 40, 160);
      doc.text("__________________", 140, 160);
    } 
    else if (format === 'format2') {
      // Format 2: Requisição de Verba
      doc.setFontSize(12);
      doc.text("REPÚBLICA DE ANGOLA", 105, 20, { align: 'center' });
      doc.text("MINISTÉRIO DAS RELAÇÕES EXTERIORES", 105, 27, { align: 'center' });
      doc.text("EMBAIXADA DA REPÚBLICA DE ANGOLA NO JAPÃO", 105, 34, { align: 'center' });
      
      doc.setFontSize(14);
      doc.text("REQUISIÇÃO DE VERBA Nº 174 / 2024", 105, 50, { align: 'center' });

      doc.setFontSize(12);
      doc.text("Parecer", 40, 65);
      doc.text("Despacho", 140, 65);

      doc.text("A", 20, 85);
      doc.text("Sua Excelência senhor(a) Embaixador", 30, 85);
      doc.text("Por intermédio desta, o sector de finanças solicita a autorização para o pagamento da seguinte", 20, 92);
      doc.text("despesa:", 20, 99);

      doc.text("YJP", 20, 110);
      doc.text("Beneficiário", 70, 110);
      doc.text("Descrição", 140, 110);

      doc.setFont("bold");
      doc.text("10.000", 20, 118);
      doc.setFont("normal");
      doc.text("Medical Center- JP29", 70, 118);
      doc.text("Pagamento de consultas médicas", 140, 118);

      doc.setFontSize(12);
      doc.text("Órgão", 20, 140);
      doc.text("Mirex", 70, 140);
      doc.text("Fonte de Recurso", 20, 147);
      doc.text("Recursos do Tesouro", 70, 147);
      doc.text("Nat. de Despesa", 20, 154);
      doc.text("Serviços de Saúde", 70, 154);
      doc.text("Conta", 20, 161);
      doc.text("001-7147734", 70, 161);
      doc.text("Câmbio", 20, 168);
      doc.text("173,04", 70, 168);
      doc.text("Equivalente-USD", 20, 175);
      doc.text("50", 70, 175);
      doc.text("Nº da Factura", 20, 182);
      doc.text("S/N", 70, 182);

      doc.setFontSize(12);
      doc.text("Tóquio, 5 de Agosto de 2024", 20, 200);
    }

    // Display PDF in a new tab
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl, "_blank");

    // Download PDF
    doc.save(`${format}-document.pdf`);
  };

  return (
    <button onClick={generatePDF}>
      Generate PDF
    </button>
  );
};

export default GeneratePDF;
